import { render, staticRenderFns } from "./setTreeData.vue?vue&type=template&id=6e92aade&scoped=true&"
import script from "./setTreeData.vue?vue&type=script&lang=js&"
export * from "./setTreeData.vue?vue&type=script&lang=js&"
import style0 from "./setTreeData.vue?vue&type=style&index=0&id=6e92aade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e92aade",
  null
  
)

export default component.exports